import { useRegisterSW } from 'virtual:pwa-register/react';

/**
 * Bandeau de mise à jour PWA.
 *
 * Quand une nouvelle version de l'application est déployée, le service worker
 * la détecte et bascule `needRefresh` à true. On affiche alors un bandeau
 * proposant à l'utilisateur de recharger pour appliquer la mise à jour.
 *
 * Cela évite d'avoir à supprimer/recréer le raccourci PWA pour obtenir
 * la dernière version.
 */
export default function UpdatePrompt() {
    const {
        needRefresh: [needRefresh, setNeedRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegisteredSW(swUrl, registration) {
            // Vérifie périodiquement si une nouvelle version est disponible
            // (utile pour un PWA installé qui n'est jamais "rechargé").
            if (registration) {
                setInterval(() => {
                    registration.update();
                }, 60 * 60 * 1000); // toutes les heures
            }
        },
    });

    if (!needRefresh) {
        return null;
    }

    return (
        <div className="toast toast-bottom toast-center z-50 w-full max-w-md px-4">
            <div className="alert bg-base-200 border border-base-300 shadow-lg flex-col items-stretch gap-3 sm:flex-row sm:items-center">
                <div className="flex items-center gap-2">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 shrink-0 text-primary"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                        />
                    </svg>
                    <span className="text-sm">Une nouvelle version est disponible.</span>
                </div>
                <div className="flex gap-2 justify-end">
                    <button
                        type="button"
                        className="btn btn-sm btn-ghost"
                        onClick={() => setNeedRefresh(false)}
                    >
                        Plus tard
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={() => updateServiceWorker(true)}
                    >
                        Mettre à jour
                    </button>
                </div>
            </div>
        </div>
    );
}
